import {Container} from 'react-bootstrap';

export default function AboutPage() {
    return (
        <Container className="about-page">
            <h1>About</h1>
            <p>Hello there! This is a simple social media clone that tries to replicate some of my favorite features of other social media websites commonly used for blogging and microblogging. Feel free to register an account and test it out!
            </p>
        </Container>
    )
}